import { render, staticRenderFns } from "./giuseppe-mascarello-e-figlio.vue?vue&type=template&id=7599edda&scoped=true"
import script from "./giuseppe-mascarello-e-figlio.vue?vue&type=script&lang=js"
export * from "./giuseppe-mascarello-e-figlio.vue?vue&type=script&lang=js"
import style0 from "./giuseppe-mascarello-e-figlio.vue?vue&type=style&index=0&id=7599edda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599edda",
  null
  
)

export default component.exports